<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { T } from '@tolgee/vue'
import { ref } from 'vue'
import { useAuth } from '@/composables/auth'
import webapp from '@/services/webapp'

defineProps<{
  show: boolean
}>()

const emit = defineEmits(['hide'])

const { deleteAccount: _deleteAccount } = useAuth()

const isDeletingAccount = ref(false)

async function deleteAccount() {
  isDeletingAccount.value = true
  _deleteAccount().then(() => {
    webapp.close()
  }).catch(() => {
    console.log('delete error')
  })
    .finally(() => {
      isDeletingAccount.value = false
      emit('hide')
    })
}
</script>
<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <h2 class="text-2xl font-bold -tracking-[0.48px] uppercase text-light-white text-center">
        <T
          key-name="settings.delete_account_confirmation.title"
          default-value="You are about to permanently delete your account"
        />
      </h2>
      <p class="text-center mb-8">
        <T
          key-name="settings.delete_account_confirmation.description"
          default-value="Please confirm that you want to proceed and permanently delete your account."
        />
      </p>
      <div class="w-full flex flex-col gap-y-3">
        <BaseButton
          style-type="delete"
          :loading="isDeletingAccount"
          @click="deleteAccount"
        >
          <T
            key-name="settings.delete_account"
            default-value="Delete account"
          />
        </BaseButton>
        <BaseButton
          style-type="secondary"
          @click="$emit('hide')"
        >
          <T
            key-name="general.cancel"
            default-value="Cancel"
          />
        </BaseButton>
      </div>
    </div>
  </TheBottomSheet>
</template>